export default "__VITE_ASSET__BQBUU3Q6__";